<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->
<ng-container>
<mat-sidenav-container [hasBackdrop]="false" class="" *ngIf="(isLoggedIn$ | async) && (user$ | async) as user; else userNotLoadedYet">
    <mat-sidenav *ngIf="showNav | async"
        role="navigation"
        fixedInViewport="true"
        class="mat-elevation-z1 sidenav"
        [autoFocus]="true"
        [ngClass]="checkLoadedAndIsExpanded()"
        [disableClose]="true"
        [opened]="true">
        <mat-nav-list [disableRipple]="true">
            <div id="inner-nav-wrapper" class="inner-nav-wrapper">
                <div>
                    <div>
                        <mat-list-item class="first-list-item" style="height: 65px;">
                            <div class="nav-logo-wrapper">
                                <span *ngIf="isExpanded && !memoizedIsResellerOrMSP(user)" aria-label="Company logo"
                                  [ngClass]="{'light-theme-logo cigent-logo': partnerId === cigentPartner ||
                                              partnerId === doqubizPartner || partnerId === digistorPartner,
                                  'dark-theme-logo lenovo-logo': partnerId === lenovoPartner,
                                  'dark-theme-logo-kanguru kanguru-logo': partnerId === kanguruPartner,
                                  'light-theme-logo-vrs vrs-logo': partnerId === vrsPartner}">
                                </span>
                                <span *ngIf="!isExpanded && !memoizedIsResellerOrMSP(user)" aria-label="Company logo"
                                  [ngClass]="{'light-theme-logo cigent-logo': partnerId === cigentPartner ||
                                              partnerId === doqubizPartner || partnerId === digistorPartner,
                                  'dark-theme-small-logo lenovo-small-logo': partnerId === lenovoPartner,
                                  'dark-theme-small-logo-kanguru kanguru-small-logo': partnerId === kanguruPartner,
                                  'light-theme-logo-vrs vrs-logo-small': partnerId === vrsPartner}">
                                </span>

                                <span *ngIf="memoizedIsResellerOrMSP(user)" aria-label="Company logo"
                                  [ngClass]="{'light-theme-logo cigent-logo': partnerId === cigentPartner ||
                                              partnerId === doqubizPartner || partnerId === digistorPartner,
                                  'dark-theme-small-logo lenovo-small-logo': partnerId === lenovoPartner,
                                  'dark-theme-small-logo-kanguru kanguru-small-logo': partnerId === kanguruPartner,
                                  'light-theme-logo-vrs vrs-logo-small': partnerId === vrsPartner}">
                                </span>
                                <div class="mat-list-logo-text">
                                    <div class="company-name" matLine *ngIf="isExpanded && (partnerId === cigentPartner ||
                                        partnerId === doqubizPartner || partnerId === digistorPartner)">CIGENT</div>
                                    <div class="company-name" matLine *ngIf="isExpanded && partnerId === lenovoPartner"></div>
                                    <div [ngClass]="{'reseller-title': partnerId !== lenovoPartner, 'reseller-title-lenovo': partnerId === lenovoPartner,
                                        'fade-in': isExpanded, 'fade-out': !isExpanded}"
                                         matLine *ngIf="isExpanded && memoizedIsReseller(user)">{{fResellers}}</div>
                                    <div [ngClass]="{'msp-title': partnerId !== lenovoPartner, 'msp-title-lenovo': partnerId === lenovoPartner,
                                        'fade-in': isExpanded, 'fade-out': !isExpanded}"
                                         matLine *ngIf="isExpanded && memoizedIsMSP(user)">{{fMSPs}}</div>
                                </div>
                                <div [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}" style="position: absolute; left: 9px; top: 49px; font-size: 14px; caret-color: transparent;"
                                    matLine *ngIf="partnerId === lenovoPartner &&
                                          isExpanded && !memoizedIsReseller(user) && !memoizedIsMSP(user)">Data Defense <span style="font-size: 10px; caret-color: transparent;">
                                    powered by Cigent</span>
                                </div>
                            </div>
                        </mat-list-item>
                    </div>
                    <a mat-list-item *ngIf="memoizedIsD3EFreeUser(user)" class="nav-link page-link" routerLink="/profile"
                            id="myAccountNav"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{fMyAccount}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            routerLinkActive="active-link"
                            [routerLinkActiveOptions]="{ exact: false }"
                            aria-label="Button to go to My Account">
                                    <span class="mdi mdi-account nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{fMyAccount}}</span>
                    </a>

                    <a *ngIf="dynamicDashboardPageEnabled(user)" class="nav-link" routerLink="/dashboard" tourAnchor="nav-menu-dashboard"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{fDashboard}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            aria-label="Button to go to Dashboard">
                        <mat-list-item id="dashboardNav" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="page-link">
                            <span class="mdi mdi-view-dashboard nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{'dashboard.title' | translate}}</span>
                        </mat-list-item>
                    </a>

                    <a *ngIf="organizationsEnabled(user)" class="nav-link" routerLink="organizations"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{fOrganizations}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            aria-label="Button to go to Organizations">
                        <mat-list-item id="manageUsersNav" routerLinkActive="active-link" class="page-link">
                            <span class="mdi mdi-domain nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{fOrganizations}}</span>
                        </mat-list-item>
                    </a>

                    <a *ngIf="endpointsPageEnabled(user)" class="nav-link" routerLink="/endpoints" tourAnchor="nav-menu-endpoints"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{fEndpoints}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            aria-label="Button to go to Endpoints">
                        <mat-list-item id="endpointNav" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="page-link">
                            <span class="mdi mdi-monitor nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{fEndpoints}}</span>
                        </mat-list-item>
                    </a>

                    <a *ngIf="secureSsdPageEnabled(user)" class="nav-link" routerLink="/secure-ssd" tourAnchor="nav-menu-secure-ssd"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{fSSSD}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            aria-label="Button to go to Secure SSD page">
                        <mat-list-item id="secureSsdNav" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }" class="page-link">
                            <span class="mdi mdi-harddisk nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{fSSSD}}</span>
                        </mat-list-item>
                    </a>


                    <a *ngIf="threatHistoryEnabled(user)" class="nav-link" routerLink="/history"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{fHistory}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            aria-label="Button to go to Threat History">
                        <mat-list-item id="threatHistoryNav" routerLinkActive="active-link" class="page-link">
                            <span class="mdi mdi-history nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{fHistory}}</span>
                        </mat-list-item>
                    </a>

                    <a *ngIf="eventViewerEnabled(user)" class="nav-link" routerLink="/events"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{fEventViewer}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            aria-label="Button to go to Event Viewer">
                        <mat-list-item id="eventViewerNav" routerLinkActive="active-link" class="page-link">
                            <span class="mdi mdi-calendar nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{fEventViewer}}</span>
                        </mat-list-item>
                    </a>

                    <a *ngIf="policyEnabled(user)" class="nav-link" routerLink="policy"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{fPolicies}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            aria-label="Button to go to Policies">
                        <mat-list-item id="policiesNav" routerLinkActive="active-link" class="page-link">
                            <span class="mdi mdi-wallet-membership nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{fPolicies}}</span>
                        </mat-list-item>
                    </a>

                    <a *ngIf="groupsEnabled(user)" class="nav-link" routerLink="groups"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{fManageGroups}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            aria-label="Button to go to group management">
                        <mat-list-item id="groupsNav" routerLinkActive="active-link" class="page-link">
                        <span class="mdi mdi-format-list-bulleted nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{fGroups}}</span>
                        </mat-list-item>
                    </a>

                    <a *ngIf="integrationsEnabled(user)" class="nav-link"  routerLink="integrations"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{f3RDIntegrations}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            aria-label="Button to go to 3rd Party Integrations">
                        <mat-list-item id="integrationsNav" routerLinkActive="active-link" class="page-link">
                            <span class="mdi mdi-sync nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{fIntegrations}}</span>
                        </mat-list-item>
                    </a>

                    <a *ngIf="usersPageEnabled(user)" class="nav-link" routerLink="users"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{fUsers}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            aria-label="Button to go to User Management">
                        <mat-list-item id="usersNav" routerLinkActive="active-link" class="page-link">
                            <span class="mdi mdi-account-multiple nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{fUsers}}</span>
                        </mat-list-item>
                    </a>

                    <a *ngIf="adminPageEnabled(user)" class="nav-link" routerLink="admin"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{fAdminPage}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            aria-label="Button to go to the admin page">
                        <mat-list-item id="adminPageNav" routerLinkActive="active-link" class="page-link">
                            <span class="mdi mdi-account-supervisor nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{fAdmin}}</span>
                        </mat-list-item>
                    </a>

                    <a *ngIf="subscriptionsEnabled(user)" class="nav-link" routerLink="/downloads"
                                [matTooltipDisabled]="isExpanded" matTooltip="{{'downloads.page-title' | translate}}" matTooltipShowDelay="500" matTooltipPosition="right"
                                    aria-label="Button to go to downloads page">
                        <mat-list-item id="downloadsNav" routerLinkActive="active-link" class="page-link">
                            <span class="mdi mdi-download-multiple nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{'downloads.page-title' | translate}}</span>
                        </mat-list-item>
                    </a>

                    <a *ngIf="adminSettingsPageEnabled(user)" class="nav-link" routerLink="admin-settings"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{fSettings}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            aria-label="Button to go to the settings page">
                        <mat-list-item id="adminSettingsPageNav" routerLinkActive="active-link" class="page-link">
                            <span class="mdi mdi-cog nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{fSettings}}</span>
                        </mat-list-item>
                    </a>

                    <a *ngIf="restConfig?.your_products_page && subscriptionsEnabled(user)" class="nav-link" routerLink="/products"
                                [matTooltipDisabled]="isExpanded" matTooltip="{{'products.page-title' | translate}}" matTooltipShowDelay="500" matTooltipPosition="right"
                                    aria-label="Button to go to manage your products">
                        <mat-list-item id="productsNav" routerLinkActive="active-link" class="page-link">
                            <span class="mdi mdi-file-certificate-outline nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{'products.page-title' | translate}}</span>
                        </mat-list-item>
                    </a>

                    <a *ngIf="encryptionPageEnabled(user) && memoizedIsCustomer(user) || memoizedIsMSP(user) && encryptionEventViewer(user)" class="nav-link" routerLink="encryption"
                            [matTooltipDisabled]="isExpanded" matTooltip="{{fEncryption}}" matTooltipShowDelay="500" matTooltipPosition="right"
                            aria-label="Button to go to the Encryption Page to encrypt/decrypt files">
                        <mat-list-item id="encryptionPageNav" routerLinkActive="active-link" class="page-link">
                            <span class="mdi mdi-zip-box-outline nav-icon" aria-hidden="true"></span>
                            <span class="nav-title" [ngClass]="{'fade-in': isExpanded, 'fade-out': !isExpanded}">{{fDecryption}}</span>
                        </mat-list-item>
                    </a>

                </div>
                <div class="collapse-expand-button-wrapper">
                    <mat-list-item [disableRipple]="true" class="bottom-icon" aria-label="Contains the expand/collapse menu button">
                        <div class="keep-right-wrapper">
                            <div class="keep-right"
                                 id="collapse-expand-button"
                                 tabindex="0"
                                 matTooltip="Collapse sidebar"
                                 matTooltipShowDelay="500"
                                 matTooltipPosition="right"
                                 aria-label="Button that collapses/expands the sidebar" (keyup.enter)="toggleSidebarExpansion()" (click)="toggleSidebarExpansion()">
                                <span *ngIf="isExpanded; else notExpanded" class="mdi mdi-chevron-double-left toggle-icon" aria-hidden="true"></span>
                                <ng-template #notExpanded>
                                    <span class="mdi mdi-chevron-double-right toggle-icon" aria-hidden="true"></span>
                                </ng-template>
                            </div>
                        </div>
                    </mat-list-item>
                </div>
            </div>
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="sidenav-content" [ngClass]="getSideNavContentClass()" role="main">
        <mat-toolbar *ngIf="(isLoggedIn$ | async) && (showToolbar | async)">
            <mat-toolbar-row>
                <div class="title-wrapper">
                    <span class="mdi toolbar-icon" aria-hidden="true" [ngClass]="icon"></span>
                    <h1 id="toolbar-title" class="toolbar-title">{{title}}</h1>
                    <button mat-mini-fab color="primary" *ngIf="showRefreshButton$ | async" (click)="refreshClicked()"
                            matTooltip="{{'REFRESH' | translate}}">
                      <span class="mdi mdi-refresh refresh-icon"></span>
                    </button>
                </div>
                
                <span class="toolbar-spacer"></span>

                <span *ngIf="organizationsEnabled(user) && showUserFilter; else searchInput" class="select-user-wrapper">
                    <ng-container *ngIf="organizations$ | async as organizations">
                        <mat-form-field appearance="outline" subscriptSizing="dynamic" >
                            <mat-select id="user-select-control" class="mat-select-content"
                                        name="user-select"
                                        aria-label="Select Organization"
                                        [(ngModel)]="selectedOrgId"
                                        [disableOptionCentering]="true"
                                        [panelWidth]="null"
                                        [panelClass]="{'org-selector-panel': true}"
                                        [disabled]="orgSelectorDisabled$ | async"
                                        (selectionChange)="onOrgSelectChanged($event)">
                                <mat-option id="user-0" value="All">{{ userSelectorDefaultOption }}</mat-option>
                                <mat-option *ngFor="let org of organizations" id="org-{{org.name}}"
                                            [value]="org.id.toString()">
                                    {{ getCompanyDisplayName(org) }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </ng-container>
                </span>
                <ng-template #searchInput>
                    @if ((user?.role === UserRole.ADMIN || user?.role === UserRole.HELP_DESK) && user?.org_type.value === OrgType.CUSTOMER) {
                        <app-search-all></app-search-all>
                    }
                </ng-template>
                <!-- <button *ngIf="downloadEnabled(user) && !(onlyFdeSubscriptions$ | async)" class="download-btn" matTooltip="{{'W_DOWNLOAD' | translate}}" id="download"
                        aria-label="Download" (click)="downloadCigent()">
                    <span class="mdi mdi-tray-arrow-down" aria-hidden="true"></span>
                </button>
                <hr *ngIf="downloadEnabled(user) || organizationsEnabled(user) && showUserFilter" class="vertical" /> -->
                <button class="help-menu-btn" [matMenuTriggerFor]="helpMenu" id="helpMenu" tourAnchor="help-menu-button" aria-label="Help menu button">
                    {{'help.title' | translate}}
                    <span class="mdi mdi-menu-down caret"></span>
                </button>
                <mat-menu #helpMenu="matMenu">
                    @if (restConfig?.enable_tour && showTourMenu(user)) {
                        <a (click)="initializeTour(user, true)" (keyup.enter)="initializeTour(user, true)" mat-menu-item>
                                <span class="mdi mdi-comment-question-outline menu-item menu-icon" aria-hidden="true"></span>
                            <span>Start Tour</span>
                        </a>
                    }
                    <a (click)="getHelp(true)" (keyup.enter)="getHelp(true)" mat-menu-item>
                            <span class="mdi mdi-face-agent menu-item menu-icon" aria-hidden="true"></span>
                        <span>{{fSupport}}</span>
                    </a>
                    <mat-divider></mat-divider>
                    <ng-container>
                        <a *ngFor="let helpItem of (contextSensitiveHelp$ | async)" [attr.href]="helpItem.url"
                           target="_blank" rel="noopener noreferrer" mat-menu-item>
                            <span class="mdi mdi-help-circle menu-item menu-icon" aria-hidden="true"></span>
                            <span>{{helpItem.token | translate}}</span>
                        </a>
                    </ng-container>
                    <mat-divider></mat-divider>
                    <a href="{{consoleDocsURL}}"
                       target="_blank" rel="noopener noreferrer" mat-menu-item>
                            <span class="mdi mdi-help-circle menu-item menu-icon" aria-hidden="true"></span>
                        <span>{{'help.online-help' | translate}}</span>
                    </a>
                    <a href="{{consoleReleaseNotesURL}}"
                       target="_blank" rel="noopener noreferrer" mat-menu-item>
                            <span class="mdi mdi-book-open-variant menu-item menu-icon" aria-hidden="true"></span>
                        <span>{{'help.release-notes' | translate}}</span>
                    </a>
                    <mat-divider></mat-divider>
                    <a (click)="onNewsClick()" (keyup.enter)="onNewsClick()" mat-menu-item>
                            <span class="mdi mdi-information menu-item menu-icon" aria-hidden="true"></span>
                        <span>{{'help.about' | translate}}</span>
                    </a>
                </mat-menu>
                <hr class="vertical" />
                <div class="name-wrapper">
                    <div *ngIf="user?.fname && user?.lname" class="fullname">{{user?.fname}} {{user?.lname}}</div>
                    <div id="headerUsername" class="username">{{user?.username}}</div>
                </div>

                <button class="profile-btn" [matMenuTriggerFor]="menu" id="menu" aria-label="Profile menu button">
                    <span class="mdi mdi-account profile"></span>
                    <span class="mdi mdi-menu-down caret"></span>
                </button>
                <mat-menu #menu="matMenu">
                    <span *ngIf="showThemeSelector">
                        <div style="padding: 11px 16px;">
                            <span class="mdi mdi-theme-light-dark theme-icon" aria-hidden="true"></span>
                            <span style="margin-left: 10px;">
                                <mat-slide-toggle
                                    labelPosition="after"
                                    aria-labelledby="Theme selector"
                                    color="primary"
                                    [disableRipple]="true"
                                    (click)="onThemeClicked($event)"
                                    (change)="onThemeChanged($event.checked)"
                                    [checked]="(theme | async) === 'dark'">
                                    {{(theme | async) === 'dark' ? 'Dark Theme' : 'Light Theme'}}
                                </mat-slide-toggle>
                            </span>
                        </div>
                        <mat-divider></mat-divider>
                    </span>
                    <a routerLink="profile/contact" id="editProfileBtn" mat-menu-item>
                        <span class="mdi mdi-account menu-item menu-icon" aria-hidden="true"></span>
                        <span>{{fManageProfile}}</span>
                    </a>
                    <a *ngIf="isCigentUser" routerLink="profile/password" mat-menu-item>
                        <span class="mdi mdi-lock menu-item menu-icon" aria-hidden="true"></span>
                        <span>{{fChangePassword}}</span>
                    </a>
                    <a *ngIf="isCigentUser" routerLink="profile/2fa" mat-menu-item>
                        <span class="mdi mdi-key-variant menu-item menu-icon" aria-hidden="true"></span>
                        <span>{{fManage2FA}}</span>
                    </a>
                    <a *ngIf="user?.role === UserRole.ADMIN && !memoizedIsD3EFreeUser(user) && notificationsEnabled(user)" routerLink="profile/settings" mat-menu-item>
                        <span class="mdi mdi-cog menu-item menu-icon" aria-hidden="true"></span>
                        <span>{{fNotifications}}</span>
                    </a>

                    @if (user.role === UserRole.ADMIN ||
                            user.role === UserRole.HELP_DESK ||
                            user.security_approver === SecurityApproverState.APPROVER ||
                            user.security_approver === SecurityApproverState.APPROVER_PENDING) {
                        <mat-divider></mat-divider>
                        <a mat-menu-item (click)="showRequestsDialog()">
                            <span class="mdi mdi-vote menu-item menu-icon" aria-hidden="true"></span>
                            <span>{{ 'SECURITY_REQUESTS' | translate }}</span>
                        </a>
                    }

                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="onLogout()">
                        <span class="mdi mdi-logout menu-item menu-icon" data-icon="sign-out-alt" aria-hidden="true"></span>
                        <span>{{fSignOut}}</span>
                    </button>
                </mat-menu>
                <hr *ngIf="notificationsEnabled(user)" class="vertical" />
                <span *ngIf="notificationsEnabled(user)">
                    <span class="mdi mdi-bell bell" id="no-alerts-bell" *ngIf="alerts.length === 0"></span>
                    <span class="mdi mdi-bell-alert have-alerts" id="have-alerts-bell" *ngIf="alerts.length > 0" (keyup.enter)="toggleNotifications()" (click)="toggleNotifications()" role="button" aria-label="View Alerts" tabindex="0"></span>
                </span>
            </mat-toolbar-row>
        </mat-toolbar>
        <div *ngIf="showUpdateBanner" class="refresh-banner">
            {{fNewVersion}}
            <button mat-flat-button color="primary" id="RefreshButton" (click)="onUpdateApp()" aria-label="A new app update is available. Refresh the page to get the update.">
                {{fUpdate}}
            </button>
        </div>
        <div *ngIf="showExpirationBanner && (isLoggedIn$ | async) && (showBanners | async)" class="expiration-banner">
            {{fExpiredA}}
            {{fExpiredB}}<a routerLink="endpoints">{{'APP_ENDPOINTS' | translate}}</a>{{fExpiredC}}
        </div>
        <div *ngIf="user && user.is_superuser && (isLoggedIn$ | async) && (showBanners | async); else showAdministratorBanner" class="superuser-banner">
            {{fSuperUser}}
        </div>
        <ng-template #showAdministratorBanner>
            <div *ngIf="(user?.administrator || user?.administrator_ro) && (isLoggedIn$ | async)" class="superuser-banner">
                You are administrator--proceed with caution.
            </div>
        </ng-template>
        <ng-container *ngIf="(isLoggedIn$ | async) && (showBanners | async)">
            <app-security-approval-banner></app-security-approval-banner>
            <app-priority-lock-banner></app-priority-lock-banner>
        </ng-container>
        <div class="router-outlet-container">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #userNotLoadedYet>
    <div class="logged-out-router-outlet-container">
        <div class="router-outlet-container" *ngIf="!(isLoggedIn$ | async) || (maintenanceMode$ | async)">
            <router-outlet></router-outlet>
        </div>
    </div>
</ng-template>

<div class="alert-panel-backdrop" *ngIf="alerts.length > 0 && alertPanelShown" (click)="backdropClicked()" ></div>


<div [className]="alertPanelShown ? 'alert-panel alert-panel-shown' : 'alert-panel alert-panel-hidden'" (keyup.escape)="toggleNotifications()" #alertPanel>
    <div *ngIf="alerts.length > 0">
        <div class="dismiss-all-alert-panel-backdrop" *ngIf="dismissAllPanel" (click)="dismissAllPanel=false"></div>
        <h3 class="notifications-title">{{fNotifications}}
            <span class="mdi mdi-dots-vertical dismiss-all-menu" (click)="dismissAllPanel=!dismissAllPanel" (keyup.enter)="dismissAllPanel=!dismissAllPanel" tabindex="0" #dismissAllMenu aria-label="Dismiss All Menu"></span>
        </h3>
        <button mat-flat-button color="primary" class="dismiss-all-panel" *ngIf="dismissAllPanel" (click)="clearAllAlerts()" tabindex="0" (keyup.enter)="clearAllAlerts()">{{fClearNotifications}}</button>
        <div class="list-wrapper">
            <div [className]="detailsShown ? 'details details-shown' : 'details details-hidden'" #detailsDiv>
                <div *ngIf="details">
                    <div class="close-details" id="close-details" (click)="hideDetails()">
                        <div class="dismiss-alert-wrapper">
                            <span class="mdi mdi-delete dismiss-alert" id="dismiss-alert" *ngIf="details.dismissed === 0" (click)="dismissAlert(details)" (keyup.enter)="dismissAlert(details)" tabindex="0"></span>
                        </div>
                        <span role="link" tabindex="0" aria-label="Close Details" #closeDetailsLink (keyup.enter)="hideDetails()"><span class="mdi mdi-arrow-left" style="font-size: 20px"></span> <span>{{fBack}}</span></span>
                    </div>

                    <h2 class="details-title" id="detail-reasons">{{fReasons}}</h2>
                    <div class="details-content">
                        <div *ngFor="let sensor of getDescriptions(details.state.activeLock)">{{ sensor }}</div>
                    </div>

                    <h2 class="details-title" id="detail-host">{{fHost}}</h2>
                    <div class="details-content">
                        <div><a [routerLink]="['/device', details.uuid]" (click)="$event.stopPropagation()">{{ details.computer_name }}</a></div>
                    </div>

                    <h2 class="details-title" id="detail-datetime">{{fDate}} &amp; {{fTime}}</h2>
                    <div class="details-content">
                        <div>{{ details.event_dttm | date :'MMM d yyyy, h:mm:ssa'}}</div>
                    </div>

                    <ng-container *ngIf="details.state && details.state.activeNetwork">
                        <h2 class="details-title" id="detail-network">{{fNetworks}}</h2>
                        <div class="details-content">
                            <div *ngFor="let net of details.state.activeNetwork">{{ net.name }} {{ net.ipv4Address }}</div>
                        </div>
                    </ng-container>

                    <h2 class="details-title" id="detail-control">{{fControl}}</h2>
                    <div class="details-content">
                        <div *ngIf="details.state && details.state.allowDeactivate">{{fUserInfo}}</div>
                    </div>
                </div>
            </div>

            <div class="scrollable-alerts">
                <ng-container *ngFor="let alert of alerts; let i=index">
                    <div *ngIf="i<alertsMaxDisplay" id="alert-list-item" class="alert-list-item" (click)="showDetails(i)">
                        <div>
                            <span tabindex="0" (keyup.enter)="showDetails(i)" role="link"
                                  [attr.aria-label]="'Details for alert ' + (i + 1)">{{fActiveLockEngage}}
                            </span>
                            {{fOn}}
                            <a [routerLink]="['/device', alert.uuid]" (click)="$event.stopPropagation()">
                                {{ alert.computer_name }}
                            </a>
                        </div>
                        <div class="dismiss-alert-wrapper">
                            <span class="mdi mdi-delete dismiss-alert" *ngIf="alert.dismissed===0" tabindex="0"
                                  (keyup.enter)="dismissAlert(alert); $event.stopPropagation()"
                                  (click)="dismissAlert(alert); $event.stopPropagation()" role="button"
                                  [attr.aria-label]="'Delete alert ' + (i + 1)">
                            </span>
                            <mat-spinner class="trash-spinner" *ngIf="alert.dismissed===1" diameter="20"></mat-spinner>
                        </div>
                        <div>{{ alert.event_dttm | date :'MMM d yyyy, h:mm:ssa'}}</div>
                    </div>
                </ng-container>
                <div *ngIf="alertsCount > alertsMaxDisplay" style="text-align: center;cursor: pointer;" (click)="showMoreAlerts()" class="show-more">
                    {{fShowMore}}
                </div>
            </div>
        </div>
    </div>
</div>

<app-user-tour #userTour></app-user-tour>

</ng-container>
